module.exports = __webpack_public_path__ + "img/+.b506cb23.png";